export default __webpack_public_path__ + "static/media/Stop.eaad798a.svg";